import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
    selector: '[tc-select-input-loading]',
    imports: [
        CommonModule,
        MatProgressSpinnerModule
    ],
    templateUrl: './select-input-loading.component.html',
    styleUrls: ['./select-input-loading.component.scss']
})
export class SelectInputLoadingComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

} 
